<!--
-->
<template>
    <div id="TenderFolder" class="clearfix gibson px2 mb4">
        <div class="mt2 pointer">
          <i class="el-icon-back" @click="gotomenikunder()"></i>
        </div>
        <div class="col-12 px0">
          <p class="h4 semi-bold line-height-2 my2">Billeddokumentation</p>
          <p class="h5 regular darkblue gibson line-height-golden mb3 col-12 px0">
            Upload billederne af dine projektforløb her, så husejeren kan se på deres app.
          </p>
        </div>
        <div class="clearfix" v-if="loading">
          <Loading></Loading>
        </div>
        <div class="col-12" v-else>
          <div class="mt3 ">
            <ol class="breadcrumb transparent px0 mb-0">
              <li class="h6 breadcrumb-item pointer" v-for="(folder, index) in parentFolderData" :key="index"
                @click="folderChange(folder.folderId, folder.folderName, currentFolderParentId, index, 'out')">
                <a>{{ folder.folderName }}</a>
              </li>
            </ol>
        </div>
            <p class="m0 h6 col-12 flex justify-start my2"  v-if="insideFolder !== 'in'">Udbudsmappe</p>
            <div class="flex flex-wrap pb4 mt1">
            <!-- sample only -->
              <!-- <div class="pointer mx2 flex flex-column border light-highlights p2 px3" @click="tenderview(item)">
                <el-tooltip content="Sample-Tender-File" placement="top-start" effect="light">
                  <span class="darkblue">
                    <svg xmlns="http://www.w3.org/2000/svg" id="pdf_ic" width="55" height="75" viewBox="0 0 55 75">
                      <path id="Path_392" data-name="Path 392" d="M59.773,62.32a27.863,27.863,0,0,1-1.966-2.263,22.185,22.185,0,0,1-1.818-2.485c1.1-3.191,2.239-7.458,1.634-10.1a3.171,3.171,0,0,0-3.149-2.779l-.17.012a3.789,3.789,0,0,0-3.06,2.716c-.9,2.63-.12,6.527,2.08,10.46a71.82,71.82,0,0,1-3.046,6.954c-2.556,1.011-5.967,2.693-8.013,5.036-2.219,2.539-1.941,4.8-1.314,6.243l.148.252.036.05a2.381,2.381,0,0,0,1.857.925,3.216,3.216,0,0,0,1.537-.442c1.949-1.074,4.722-4.81,7.431-10.015a40.78,40.78,0,0,1,6.986-1.874c3.851,3.654,8.08,5.454,10.566,4.487a3.188,3.188,0,0,0,1.963-3.179,3.9,3.9,0,0,0-2.8-3.612C66.725,61.911,63.568,61.781,59.773,62.32ZM54.939,60.39c.337.46.688.91,1.05,1.335.292.377.6.75.9,1.109-1.139.246-2.272.54-3.383.875C54.023,62.6,54.5,61.493,54.939,60.39Zm.351-12.319c.3,1.32-.006,3.609-.86,6.521-1.044-2.494-1.409-4.89-.927-6.3a1.368,1.368,0,0,1,1.061-1.044C54.817,47.255,55.115,47.3,55.29,48.071ZM48.3,68.483c-1.9,3.227-3.678,5.486-4.873,6.142a1.112,1.112,0,0,1-.4.151c-.329-1.011-.011-2.023.988-3.167A14.9,14.9,0,0,1,48.3,68.483Zm14-3.9a13.378,13.378,0,0,1,5.527.5c1.225.492,1.242,1.088,1.247,1.275,0,.575-.223.661-.387.727C67.639,67.5,65.122,66.736,62.3,64.583Z" transform="translate(-28.492 -31.709)" fill="#134553"/>
                      <path id="Path_393" data-name="Path 393" d="M53.916,14.4,40.948,1.114A3.643,3.643,0,0,0,38.325,0H3.71A3.762,3.762,0,0,0,0,3.8V71.2A3.762,3.762,0,0,0,3.71,75H51.29A3.762,3.762,0,0,0,55,71.2V17.087A3.811,3.811,0,0,0,53.916,14.4ZM52.537,52.455V71.2a1.282,1.282,0,0,1-.366.9,1.226,1.226,0,0,1-.878.375H3.71A1.261,1.261,0,0,1,2.466,71.2V52.458H52.537ZM40.582,13.723V4.311l10.21,10.461H41.609A1.038,1.038,0,0,1,40.582,13.723ZM41.609,17.3H52.537V49.926H2.466V3.8A1.261,1.261,0,0,1,3.71,2.526H38.116v11.2A3.539,3.539,0,0,0,41.609,17.3Z" transform="translate(0 0)" fill="#134553"/>
                      <path id="Path_394" data-name="Path 394" d="M47.348,203.788a1.278,1.278,0,0,0,1.278-1.278V199.17h2.367a3.647,3.647,0,0,0,3.642-3.645v-2.014a3.646,3.646,0,0,0-3.642-3.642H47.348a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,47.348,203.788Zm1.278-7.174v-4.187h2.367a1.087,1.087,0,0,1,1.085,1.088v2.014a1.088,1.088,0,0,1-1.085,1.088H48.626Z" transform="translate(-32.976 -134.449)" fill="#134553"/>
                      <path id="Path_395" data-name="Path 395" d="M82.618,203.795h3.4a3.894,3.894,0,0,0,3.888-3.888v-6.142a3.889,3.889,0,0,0-3.885-3.885h-3.4a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,82.618,203.795Zm1.278-2.556v-8.8H86.02a1.333,1.333,0,0,1,1.332,1.332v6.142a1.333,1.333,0,0,1-1.332,1.332Z" transform="translate(-58.222 -134.456)" fill="#134553"/>
                      <path id="Path_396" data-name="Path 396" d="M118.588,203.795a1.278,1.278,0,0,0,1.278-1.278v-4.4h2.657a1.278,1.278,0,1,0,0-2.556h-2.657v-3.123H124.6a1.278,1.278,0,1,0,0-2.556h-6.011a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,118.588,203.795Z" transform="translate(-83.969 -134.456)" fill="#134553"/>
                    </svg>
                  </span>
                </el-tooltip>
                <span class="darkblue center">File 0</span>
              </div> -->
              <!-- eslint-disable -->
              <!-- <div class="pointer mx2 flex flex-column border light-highlights p2 px3" v-for="(item,index) in documentsData" :key="index" @click="openpdfdownload(item.pdfbase64)"> -->
              <div class="pointer mx2 flex flex-column border light-highlights p2 px3" v-for="(item,index) in documentsData" :key="index" v-if="insideFolder !== 'in'">
                <div class='flex flex-column' v-if="item.TYPE !== 'folder'">
                <el-tooltip :content="item.NAME" placement="top-start" effect="light" >
                  <span class="darkblue">
                    <svg xmlns="http://www.w3.org/2000/svg" id="pdf_ic" width="55" height="75" viewBox="0 0 55 75">
                      <path id="Path_392" data-name="Path 392" d="M59.773,62.32a27.863,27.863,0,0,1-1.966-2.263,22.185,22.185,0,0,1-1.818-2.485c1.1-3.191,2.239-7.458,1.634-10.1a3.171,3.171,0,0,0-3.149-2.779l-.17.012a3.789,3.789,0,0,0-3.06,2.716c-.9,2.63-.12,6.527,2.08,10.46a71.82,71.82,0,0,1-3.046,6.954c-2.556,1.011-5.967,2.693-8.013,5.036-2.219,2.539-1.941,4.8-1.314,6.243l.148.252.036.05a2.381,2.381,0,0,0,1.857.925,3.216,3.216,0,0,0,1.537-.442c1.949-1.074,4.722-4.81,7.431-10.015a40.78,40.78,0,0,1,6.986-1.874c3.851,3.654,8.08,5.454,10.566,4.487a3.188,3.188,0,0,0,1.963-3.179,3.9,3.9,0,0,0-2.8-3.612C66.725,61.911,63.568,61.781,59.773,62.32ZM54.939,60.39c.337.46.688.91,1.05,1.335.292.377.6.75.9,1.109-1.139.246-2.272.54-3.383.875C54.023,62.6,54.5,61.493,54.939,60.39Zm.351-12.319c.3,1.32-.006,3.609-.86,6.521-1.044-2.494-1.409-4.89-.927-6.3a1.368,1.368,0,0,1,1.061-1.044C54.817,47.255,55.115,47.3,55.29,48.071ZM48.3,68.483c-1.9,3.227-3.678,5.486-4.873,6.142a1.112,1.112,0,0,1-.4.151c-.329-1.011-.011-2.023.988-3.167A14.9,14.9,0,0,1,48.3,68.483Zm14-3.9a13.378,13.378,0,0,1,5.527.5c1.225.492,1.242,1.088,1.247,1.275,0,.575-.223.661-.387.727C67.639,67.5,65.122,66.736,62.3,64.583Z" transform="translate(-28.492 -31.709)" fill="#134553"/>
                      <path id="Path_393" data-name="Path 393" d="M53.916,14.4,40.948,1.114A3.643,3.643,0,0,0,38.325,0H3.71A3.762,3.762,0,0,0,0,3.8V71.2A3.762,3.762,0,0,0,3.71,75H51.29A3.762,3.762,0,0,0,55,71.2V17.087A3.811,3.811,0,0,0,53.916,14.4ZM52.537,52.455V71.2a1.282,1.282,0,0,1-.366.9,1.226,1.226,0,0,1-.878.375H3.71A1.261,1.261,0,0,1,2.466,71.2V52.458H52.537ZM40.582,13.723V4.311l10.21,10.461H41.609A1.038,1.038,0,0,1,40.582,13.723ZM41.609,17.3H52.537V49.926H2.466V3.8A1.261,1.261,0,0,1,3.71,2.526H38.116v11.2A3.539,3.539,0,0,0,41.609,17.3Z" transform="translate(0 0)" fill="#134553"/>
                      <path id="Path_394" data-name="Path 394" d="M47.348,203.788a1.278,1.278,0,0,0,1.278-1.278V199.17h2.367a3.647,3.647,0,0,0,3.642-3.645v-2.014a3.646,3.646,0,0,0-3.642-3.642H47.348a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,47.348,203.788Zm1.278-7.174v-4.187h2.367a1.087,1.087,0,0,1,1.085,1.088v2.014a1.088,1.088,0,0,1-1.085,1.088H48.626Z" transform="translate(-32.976 -134.449)" fill="#134553"/>
                      <path id="Path_395" data-name="Path 395" d="M82.618,203.795h3.4a3.894,3.894,0,0,0,3.888-3.888v-6.142a3.889,3.889,0,0,0-3.885-3.885h-3.4a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,82.618,203.795Zm1.278-2.556v-8.8H86.02a1.333,1.333,0,0,1,1.332,1.332v6.142a1.333,1.333,0,0,1-1.332,1.332Z" transform="translate(-58.222 -134.456)" fill="#134553"/>
                      <path id="Path_396" data-name="Path 396" d="M118.588,203.795a1.278,1.278,0,0,0,1.278-1.278v-4.4h2.657a1.278,1.278,0,1,0,0-2.556h-2.657v-3.123H124.6a1.278,1.278,0,1,0,0-2.556h-6.011a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,118.588,203.795Z" transform="translate(-83.969 -134.456)" fill="#134553"/>
                    </svg>
                  </span>
                </el-tooltip>
                <span class="darkblue center">File {{index + 1}}</span>
                </div>
                <div class='flex flex-column' v-if="item.TYPE === 'folder'" @click="folderChange(item.ID, item.NAME, item.PARENT_ID, index,'in')">
                <el-tooltip :content="item.NAME" placement="top-start" effect="light" >
                  <span class="darkblue">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40.282" height="36.354" viewBox="0 0 40.282 36.354">
                      <path id="Folder" d="M4.6,36.354A4.253,4.253,0,0,1,.9,34.082a7.7,7.7,0,0,1-.882-2.146L0,31.859V3.8A3.564,3.564,0,0,1,1.181.942a5.182,5.182,0,0,1,3.761-.9h9.721l3.916,5.9h4.984a.75.75,0,1,1,0,1.5H17.774l-3.917-5.9H4.829l-.059-.01a3.784,3.784,0,0,0-2.62.552A2.115,2.115,0,0,0,1.5,3.8V31.69c.121.465.914,3.164,3.1,3.164H35.623c.414-.076,3.159-.668,3.159-3.178V10.452c-.022-.275-.3-3.066-2.736-3.066H31.17a.75.75,0,0,1,0-1.5h4.876A3.854,3.854,0,0,1,39.686,8.2a6.335,6.335,0,0,1,.594,2.181l0,.043V31.676a4.316,4.316,0,0,1-2.295,3.87,6.764,6.764,0,0,1-2.192.8l-.055.008ZM26.915,7.319A.8.8,0,0,1,27.22,5.78a.8.8,0,1,1,0,1.6A.8.8,0,0,1,26.915,7.319Z" transform="translate(0 0)" fill="#19a3c0"/>
                    </svg>
                  </span>
                </el-tooltip>
                <span class="darkblue center">{{item.NAME}}</span>
                </div>
              </div>
              <!-- eslint-disable -->
              <!-- Inside Folder -->
            </div>
        </div>
        <!-- Tender File Q and A -->
      <b-modal id="tenderQA" hide-footer hide-header size="lg" centered lazy v-model="tenderQA" ref="tenderQA" class="p-2 pb-4" no-close-on-backdrop no-close-on-esc>
        <div class="col-12 flex justify-end items-center white-background px0 ">
          <button type="button" class="white-button no-border not-rounded gibson " @click="closetenderqa()">
            <span> <i class="el-icon-circle-close"></i> </span>
          </button>
        </div>
        <div class="flex xs-flex-column darkblue">
          <div class="flex flex-column lg-col-7 md-col-7 xs-col-12 p0">
            <div class="clearfix" v-if="formLoading">
              <Loading></Loading>
            </div>
            <div class="p2 overflow-auto projectdesccontainer" v-else>
              <div class="col-12 p0 m0 flex">
                <span class="h5 bold darkblue">Beskrivelse</span>
                <div class="ml-auto">
                  <span><i class="el-icon-printer pointer"></i></span>
                  <span><i class="el-icon-download pointer"></i></span>
                </div>
              </div>
              <div class="bordercece p3">
                <div class=" mb2" v-for="(item,index) in productlistforpricearr" :key="index">
                  <p class="h5 p0 m0 mb1">{{(index + 1) + ' '}}<span class="semi-bold">{{primaryproductindustryname[parseInt(item.industryid)]}}</span></p>
                  <div class="flex flex-column p0 deschover"  v-for="(job,index2) in item.industrydetails" :key="index2">
                    <p class="flex m0 pl1" >
                      <span class="p0 m0 h6 line-height-golden graymuteddark">{{parseInt(index + 1) + '.'}}{{index2 + 1}}</span>
                      <span class="pl1 p0 m0 h6 line-height-golden graymuteddark">{{job.DESCRIPTION}}</span>
                      <span :id="job.ID" class="ml-auto addquestionicon pr1">
                        <el-tooltip class="item" effect="dark" content="View replies" placement="top-start">
                          <span class="small pointer" @click="selectDescIndustry(item.industryid, job.ID)" v-if="Number(getnoreplybydescId(job.ID, item.industryid) > 0)">{{Number(getnoreplybydescId(job.ID, item.industryid)) > 1 ? getnoreplybydescId(job.ID, item.industryid) + ' answers' : getnoreplybydescId(job.ID, item.industryid) + ' answer'  }}</span>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Add question" placement="top-start">
                          <i class="el-icon-chat-dot-square pointer" @click="addastags(item.industryid)"></i>
                        </el-tooltip>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p2 boder md-col-5 lg-col-5 xs-col-12 pb3">
            <div class="">
                <div class="m0 p0 mp0 lg-col-12 md-col-12 sm-col-12">
                  <p class="h5 semi-bold">Tilføj pørgsmål</p>
                  <el-form>
                  <el-select v-model="productTags" multiple filterable :multiple-limit="5" placeholder="Tags" class="col-12 p0 capital border tagSelect mb1">
                    <el-option
                      v-for="item in tagsData"
                      :key="item.key"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-form-item label="" prop="questions" class="border-none p0 ">
                      <el-input type="textarea" :rows="3" v-model="questions" class="border wizard-border white-background" placeholder="Spørgsmål"></el-input>
                  </el-form-item>
                  </el-form>
                </div>
                <div class="col-12 flex p0">
                <button class="dark-button p2 px3 not-rounded ml-auto" :disabled="disableaddbutton" @click="addquestion()">Tilføj spørgsmål</button>
                </div>
            </div>
            <!-- eslint-disable -->
            <div class="flex justify-end p0 m0 mt3"><p class="p0 m0 small pointer" @click="showall()" v-if="defaultallquestionsanswerArr.length !== allquestionsanswerArr.length && allquestionsanswerArr.length > 0">Show All</p></div>
            <div class="overflow-auto pt1" :class="defaultallquestionsanswerArr.length > 0 && allquestionsanswerArr.length < 1 ? 'border muted-border ' : null" style="height:483px;">
              <div class="flex flex-column justify-center">
                <div class="clearfix" v-if="innerloading">
                  <Loading></Loading>
                </div>
                <div v-else>
                <div class="mb1" v-for="(questions,index) in allquestionsanswerArr" :key="index" v-if="allquestionsanswerArr.length > 0" >
                  <div class="p2 questiondiv flex flex-column">
                    <div class="pb1" v-if="Number(haaId) === questions.UF_PARTNER_ID"> <p class="m0 h6 semi-bold"> You </p></div>
                    <div class="pb1" v-else-if="questions.UF_MESSAGE_FROM === Number(contactID)"> <p class="m0 h6 semi-bold"> Homeowner </p></div>
                    <div class="" v-else> <p class="m0">Craftsman</p></div>
                    <div class="flex flex-wrap p0 m0">
                      <div class="industryquestionsdiv px1 questionsgray flex p0 m0 items-center mb1 mr1" v-for="industry in questions.INDUSTRY">
                        <p class="m0 p0 lowercase font14">{{(industry.NAME)}}</p>
                      </div>
                    </div>
                    <div class="p0 m0"><p class="m0 font14 questionsgray">{{questions.UF_MESSAGE}}</p></div>
                    <div class="flex p0 m0 small mt2">
                      <p class="m0 font14">{{questions.TOTAL_REPLY}} Samlet svar</p>
                      <p class="m0 ml-auto font14 pointer" v-if="questions.TOTAL_REPLY > 0" @click="viewanswers(index, questions.ID)">Se svar</p>
                      <p class="m0 ml-auto font14 pointer" v-else @click="addchildreplay(questions.ID)">Svar</p>
                    </div>
                  </div>
                  <div class="ml2 p2 flex flex-column font14 relative" v-if="questions['childquestionsanswers'].length > 0">
                    <div class="questiondiv p2" v-for="otherchild in questions['childquestionsanswers']">
                      <p class="m0 primarycolor" v-if="otherchild.UF_MESSAGE_FROM === Number(contactID)">Homeowner</p>
                      <p class="m0 primarycolor" v-else-if="otherchild.UF_MESSAGE_FROM === Number(haaId)">You</p>
                      <p class="m0 darkblue">{{otherchild.UF_MESSAGE}}</p>
                    </div>
                      <p class="m0 absolute bottom-0 right-0 px2 pointer" style="bottom: -5px;" @click="addchildreplay(questions.ID)">Svar</p>
                  </div>
                  <div :id="'reply' + questions.ID" class="ml2 p2 my1 flex hide">
                    <el-input type="textarea" :rows="1" v-model="replayanswer" class="border wizard-border white-background" placeholder="Spørgsmål"></el-input>
                    <button class="small action-button pointer" @click="addreplytoanswers(questions.ID, index)">Indsend</button>
                    <button class="small outlined-standard-button pointer" @click="hidechildreply(index, questions.ID)">Afbestille</button>
                  </div>
                </div>
                    </div>
                  </div>
              </div>
            <!-- eslint-enable -->
          </div>
        </div>
      </b-modal>
      <b-modal  centered hide-header hide-footer id="downloadpdf" size="lg" ref="downloadpdf">
        <div class="col-12 flex justify-end items-center white-background px0 ">
          <button type="button" class="white-button no-border not-rounded gibson " @click="closepdfdownload()">
            <span> <i class="el-icon-circle-close"></i> </span>
          </button>
        </div>
        <div class="py1 col-12 p0 relative" style="width:100%;overflow:auto;" >
        <div class="col-9 p0 mx-auto">
          <!-- <b-embed type="iframe" scrolling="no" :src="selectedtender" aspect="1by1"  allowfullscreen ></b-embed> -->
          <ejs-pdfviewer  id="pdfViewer" ref="pdfviewer" :serviceUrl="serviceUrl"  :enableToolbar="false" height="800px" > </ejs-pdfviewer>
          </div>
        </div>
      </b-modal>
      <ErrorHandler ref="errorMsg"></ErrorHandler>
    </div>
</template>

<script>
const Loading = () => import('@/components/Loading')
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  components: {
    Loading,
    ErrorHandler
  },
  data () {
    return {
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      loading: false,
      projectID: '',
      contactID: '',
      haaId: '',
      salesPersonbitrix: '',
      tenderFolderID: '',
      formLoading: false,
      searchQuery: '',
      documentsData: [],
      defaultFolderId: '',
      parentFolderData: [],
      currentFolderId: '',
      currentFolderParentId: '',
      currentProjectInfo: {},
      selectedtender: '',
      projectAddress: '',
      tenderQA: false,
      productlistforpricearr: [],
      primaryproductindustryname: {},
      tagsData: [],
      productTags: [],
      questions: '',
      projectTitle: '',
      allquestionsanswerArr: [],
      defaultallquestionsanswerArr: [],
      disableaddbutton: false,
      selectedIndustryDesc: {
        industryid: '',
        industrydesc: ''
      },
      innerloading: false,
      replayanswer: '',
      alldescriptionidwithreply: [],
      viewer: {},
      serviceUrl: '',
      partnerName: '',
      documentPath: '',
      publicFiles: [],
      seletecdfolder: 'default',
      parent_tenderID: '',
      selectedFolder: '',
      insideFolder: ''
    }
  },
  created () {
  },
  mounted () {
    this.serviceUrl = 'https://sea-turtle-app-n3xkw.ondigitalocean.app/api/pdfviewer'
    this.projectID = this.$route.query.projectID
    this.contactID = this.$route.query.contact_id
    this.tenderFolderID = this.$route.query.tenderFolderID
    this.parent_tenderID = this.$route.query.parent_tenderID
    this.projectTitle = this.$route.query.title
    this.partnerName = localStorage.getItem('name')
    this.projectAddress = this.$route.query.address
    this.haaId = localStorage.getItem('haaid')
    this.getallwizardproduct()
    this.displaytenderFiles(this.parent_tenderID)
    this.getQuestionsAnswers()
    this.getPublicFiles()
    // this.runmainwebviewer()
  },
  methods: {
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// projekt-billeder.vue?c3f2bf76